import { render } from "./Action.vue?vue&type=template&id=1255d2cc&bindings={\"expanded\":\"data\",\"shape\":\"props\",\"title\":\"props\",\"subtitle\":\"props\",\"soundscapeLabel\":\"props\",\"expandedClass\":\"options\",\"tapped\":\"options\",\"mouseLeft\":\"options\",\"mouseEntered\":\"options\"}"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"

import "./Action.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script